// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nUkF","left":"styles_left__3ERi1","desktopActions":"styles_desktopActions__2URV9","title":"styles_title__1WWnq"};